var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:{
    plain: _vm.plain,
  },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }